import { GET_CONFIG, GET_TAGS } from "./mutation-types"

export default {
    [GET_CONFIG]: (state, config) => {
      state.config = config
    },
    [GET_TAGS]: (state, tags) => {
      state.tags = tags
    },
}